import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useShallow } from "zustand/shallow";

import { setUserSession } from "@/services/api/utils/auth";
import { useBoundStore } from "@/app/store";

export function useNavigation() {
  const { redirect, setRedirect } = useBoundStore(
    useShallow((state) => ({ redirect: state.navigation.redirect, setRedirect: state.navigation.setRedirect }))
  );
  const location = useLocation();
  const navigate = useNavigate();

  /**
   * Set redirect url
   */
  useEffect(() => {
    if (!redirect.location) {
      setRedirect({ location: structuredClone(location) });
    }
  }, [location, redirect.location, setRedirect]);

  useEffect(() => {
    if (redirect.location && !redirect.triggered) {
      setRedirect({ triggered: true });
      const locationPathname = redirect.location.pathname;
      const hashParams = new URLSearchParams(redirect.location.hash.slice(1));

      // Sign in with access token
      const accessToken = hashParams.get("access_token");
      if (accessToken) {
        setUserSession(hashParams);
        return;
      }

      if (locationPathname.startsWith("/settings")) {
        navigate("/home", { replace: true });
        navigate("/settings");
        return;
      }

      if (locationPathname.startsWith("/share/notes/")) {
        navigate("/home", { replace: true });
        navigate(redirect.location.pathname);
        return;
      }

      navigate("/home", { replace: true });
    }
  }, [redirect.location, redirect.triggered, location, navigate, setRedirect]);

  return null;
}
